import { render, staticRenderFns } from "./MBettingAdd.vue?vue&type=template&id=058387fd&scoped=true"
import script from "./MBettingAdd.vue?vue&type=script&lang=js"
export * from "./MBettingAdd.vue?vue&type=script&lang=js"
import style0 from "./MBettingAdd.vue?vue&type=style&index=0&id=058387fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058387fd",
  null
  
)

export default component.exports